import React, { ReactNode, useCallback } from "react";
import { CSSTransition, SwitchTransition } from "react-transition-group";
import classNames from "classnames/dedupe";

import { Button } from "../../../ActionsSelectors/Button";
import PageSpinner from "../../../FeedbackIndicators/PageSpinner/PageSpinner";
import { Link } from "../../../ActionsSelectors/Link";

export interface ILoadMoreProps {
  text?: ReactNode;
  buttonText?: ReactNode;
  isLoading?: boolean;
  isMobile?: boolean;
  linkProps?: React.ComponentProps<typeof Link>;
  onMainAction?(event: React.MouseEvent): void;
}

function LoadMore({
  text,
  buttonText = "Load more",
  isLoading,
  isMobile,
  linkProps,
  onMainAction,
}: ILoadMoreProps): JSX.Element {
  const endListener = useCallback(
    (node: HTMLElement, done: () => void) =>
      node.addEventListener("transitionend", done, false),
    [],
  );

  const ButtonContent = (
    <Button
      data-testid="LoadMore__button"
      type="button"
      variant="secondary"
      classes={{ root: "m-auto" }}
      onClick={onMainAction}
    >
      {buttonText}
    </Button>
  );

  const LoadMoreButton = linkProps ? (
    <Link classes={{ root: "text-decoration-none" }} {...linkProps}>
      {ButtonContent}
    </Link>
  ) : (
    ButtonContent
  );
  return (
    <div
      className={classNames("btn-block text-center", {
        "btn-block--mobile": isMobile,
      })}
      data-testid="LoadMore"
    >
      <div className="load-more-pre-text text-color-blue">{text}</div>
      <SwitchTransition>
        <CSSTransition
          key={String(isLoading)}
          addEndListener={endListener as any}
          classNames="uds-appear-fade"
        >
          {isLoading ? <PageSpinner /> : LoadMoreButton}
        </CSSTransition>
      </SwitchTransition>
    </div>
  );
}

export default LoadMore;
